module.exports = __webpack_public_path__ + "img/494.b0050578.jpg";